import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import type { DropzoneRootProps } from 'react-dropzone';
import Flex from '@wix/da-ds/pkg/Flex/Flex';
import Loader from '@wix/da-ds/pkg/Loader/Loader';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import UploadingLoader from '../UploadingLoader';

import s from './EmptyState.scss';

interface Props {
  isOriginals?: boolean;
  isUploading: boolean;
  hasError?: boolean;
  uploadProgress?: number;
  getDropzoneRootProps: () => DropzoneRootProps;
}

const EmptyState: React.FC<Props> = ({
  isOriginals = false,
  isUploading,
  hasError,
  uploadProgress,
  getDropzoneRootProps,
}) => {
  const { t } = useTranslation();

  if (isUploading) {
    return <UploadingLoader uploadProgress={uploadProgress} />;
  }

  return (
    <Flex direction="column" alignItems="center" {...getDropzoneRootProps()}>
      {!isOriginals && (
        <Loader size="big" state="eating_grass" />
      )}
      {isOriginals && (
        <div className={s['originals-loader']} />
      )}
      <span className={s['title']}>
        {t('originalDeviationPopup.form.coverImage.title')}
      </span>
      <span className={c(s['text'], hasError && s['has-error'])}>
        {t('originalDeviationPopup.form.coverImage.subtitle')}
      </span>
      <GhostButton className={s['add-btn']} variant="main" size="large">
        {t('originalDeviationPopup.form.coverImage.btn')}
      </GhostButton>
    </Flex>
  );
};
EmptyState.displayName = 'EmptyState';

export default EmptyState;
